export const getNextRepaymentAction = (state = {}, action) => {
  switch (action.type) {
    case "GET_NEXT_REPAYMENT":
      return action.data;

    default:
      return state;
  }
};
